import { CurrentDelivery } from "./currentDelivery.model";
import { PastDelivery } from "./pastDelivery.model";

export class DataTrack {
  currentDelivery?: CurrentDelivery;
	pastDeliveries?: PastDelivery[];
	remainingStops?: number;
	roundId?: string;
}
